<template>
  <component
    :is="componentType"
    :to="to"
    v-bind="$attrs"
    class="flex h-fit items-center justify-center rounded-md transition duration-150 ease-out-quart active:scale-[0.98] disabled:active:scale-100 motion-reduce:active:scale-100"
    :class="[
      size === 'xs' ? 'py-px px-4' : '',
      size === 'small' ? 'py-1 px-8' : '',
      size === 'medium' ? 'py-2 px-4' : '',
      size === 'large' ? 'py-4 px-8' : '',
      fontWeight === 'bold' ? 'font-bold' : '',
      fontWeight === 'medium' ? 'font-medium' : '',
      fontSize === 'xl' ? 'text-xl' : '',
      fontSize === 'md' ? 'text-md' : '',
      fontSize === 'sm' ? 'text-sm' : '',
      fontSize === 'xs' ? 'text-xs' : '',
      color === 'primary'
        ? 'bg-primary-500 text-white hover:bg-primary-400 active:bg-primary-600 active:text-white disabled:bg-primary-50 disabled:text-neutral-300'
        : '',
      color === 'primary-border'
        ? 'border border-primary-500 bg-white text-primary-500 hover:border-primary-700 hover:bg-primary-50 hover:text-primary-700 active:border-primary-700 active:bg-primary-100 disabled:border-primary-100 disabled:bg-white disabled:text-primary-100'
        : '',
      color === 'secondary'
        ? 'bg-white text-secondary-500 hover:text-secondary-300 active:bg-secondary-500 active:text-white disabled:bg-white disabled:text-secondary-100'
        : '',
      color === 'alter'
        ? 'border border-error-700 bg-white text-error-700 hover:border-error-600 hover:bg-error-50 hover:text-error-600 active:border-error-700 active:bg-error-100 disabled:border-error-100 disabled:bg-white disabled:text-error-100'
        : '',
      color === 'success'
        ? 'border border-success-700 bg-white text-success-700 hover:border-success-600 hover:bg-success-50 hover:text-success-600 active:border-success-700 active:bg-success-100 disabled:border-success-100 disabled:bg-white disabled:text-success-100'
        : '',
      color === 'alter-full'
        ? 'bg-error-500 text-white hover:bg-error-600 active:bg-error-700 disabled:bg-error-100 disabled:text-white'
        : '',
      color === 'success-full'
        ? 'bg-success-500 text-white hover:bg-success-600 active:bg-success-700 disabled:bg-success-100 disabled:text-white'
        : '',
      color === 'warning'
        ? 'border border-warning-500 bg-white text-warning-500 hover:border-warning-400 hover:bg-warning-50 hover:text-warning-400 active:border-warning-500 active:bg-warning-100 disabled:border-warning-100 disabled:bg-white disabled:text-warning-100'
        : '',
      color === 'neutral'
        ? 'bg-white text-neutral-600 hover:text-secondary-500 active:border-secondary-500 active:text-secondary-500 disabled:text-neutral-300'
        : '',
      color === 'secondary'
        ? 'border border-secondary-500 hover:border-secondary-300 active:border-secondary-500 disabled:border-secondary-100'
        : '',
      color === 'neutral'
        ? 'border border-neutral-300 hover:border-secondary-500 active:border-secondary-500 disabled:border-neutral-100'
        : ''
    ]"
    :disabled="disabled"
    :type="type"
    @click="onClick($event)"
    @mouseover="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <span class="inline-flex items-center">
      <slot />
    </span>

    <InfuseSpinner v-if="loading && !hideSpinner" class="ml-2" size="xs" variant="primary" />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  inheritAttrs: false
});
</script>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { RouteLocationRaw } from 'vue-router';

import InfuseSpinner from './InfuseSpinner.vue';

const emit = defineEmits(['click']);

interface Props {
  to?: RouteLocationRaw;
  color?:
    | 'primary'
    | 'primary-border'
    | 'secondary'
    | 'neutral'
    | 'alter'
    | 'warning'
    | 'success'
    | 'alter-full'
    | 'success-full';
  disabled?: boolean;
  loading?: boolean;
  size?: 'xs' | 'small' | 'medium' | 'large';
  fontWeight?: 'bold' | 'medium';
  type?: 'submit' | 'reset' | 'button';
  fontSize?: 'lg' | 'md' | 'sm' | 'xs';
  hideSpinner?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  to: undefined,
  color: 'primary',
  size: 'medium',
  type: 'submit',
  fontWeight: 'bold',
  fontSize: 'xs',
  hideSpinner: false,
});

const isHovering = ref<boolean>(false);

const componentType = computed(() => {
  if (props.to) {
    return 'router-link';
  }

  return 'button';
});

function onClick(event: Event) {
  emit('click', event);
}
</script>
